// THIS FILE WAS GENERATED AND SHOULD NOT BE MODIFIED!
import React from 'react';
import { Row, Col, Nav } from 'seduo-ui';
import NavLink from '../UI/NavLink';
class Utilities extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            navItems: [
                {
                    name: 'Clearfix',
                    to: 'utilities/clearfix/',
                },
                {
                    name: 'Colors',
                    to: 'utilities/colors/',
                },
                {
                    name: 'Font',
                    to: 'utilities/font/',
                },
                {
                    name: 'Shadows',
                    to: 'utilities/shadows/',
                },
                {
                    name: 'Spacing',
                    to: 'utilities/spacing/',
                },
                {
                    name: 'Truncate',
                    to: 'utilities/truncate/',
                },
            ],
        };
    }
    render() {
        return (<Row>
                <Col md={{ size: 3, order: 2 }}>
                    <div className="docs-sidebar mb-3">
                        <h5>Utilities</h5>
                        <Nav className="flex-column">
                            {this.state.navItems.map((item, i) => (<NavLink key={i} {...item}/>))}
                        </Nav>
                    </div>
                </Col>
                <Col md={{ size: 9, order: 1 }}>{this.props.children}</Col>
            </Row>);
    }
}
export default Utilities;
